import type {FC} from 'react';
import {Stack, Typography} from '@wellstone-solutions/web';
import multiBubble from 'assets/images/multi-bubble.svg';
import peaceHand from 'assets/images/peace-hand.svg';
import type {ChannelCollection} from '../../types';

interface ConversationListEmptyProps {
  variant: ChannelCollection;
}

const content: Record<
  ChannelCollection,
  {title: string; description: string; image: string}
> = {
  all: {
    title: 'Start a conversation!',
    description:
      'Click the “New Conversation” button to search for a member or staff and begin your chat.',
    image: multiBubble,
  },
  unread: {
    title: "You're all caught up!",
    description: 'Nice job staying on top of your conversations.',
    image: peaceHand,
  },
};

export const ConversationListEmpty: FC<ConversationListEmptyProps> = ({
  variant,
}) => {
  const {title, description, image} = content[variant];

  return (
    <Stack
      flex={1}
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{pt: 3}}>
      <Stack alignItems="center">
        <Typography fontSize={28} fontWeight={700}>
          {title}
        </Typography>
        <Typography fontSize={18} textAlign="center" maxWidth={320}>
          {description}
        </Typography>
      </Stack>

      <img src={image} alt="" height={132} />
    </Stack>
  );
};
